export default "__VITE_ASSET__73da4d01__"